/** Mirrors backend `cantonFairLeadConstants` and website questionnaire. */

export const PURPOSE_IDS = [
  "Reseller / Distributor",
  "Brand / D2C Seller",
  "Offline Retailer",
  "Manufacturer / OEM",
  "Bulk Importer",
  "Dropshipper",
  "Corporate Buyer",
  "Other",
];

export const PRODUCT_CATEGORIES = [
  "Electronics & Gadgets",
  "Home & Kitchen",
  "Fashion & Apparel",
  "Toys & Games",
  "Beauty & Personal Care",
  "Tools & Hardware",
  "Sports & Fitness",
  "Furniture & Decor",
  "Automotive Accessories",
  "Stationery & Office",
  "Baby Products",
  "Pet Products",
  "Lighting & Electrical",
  "Packaging & Supplies",
  "Industrial Equipment",
  "Other",
];

export const PLATFORMS = [
  "Amazon India",
  "Flipkart",
  "Meesho",
  "Myntra",
  "Nykaa",
  "AJIO",
  "JioMart",
  "Snapdeal",
  "My Own Website/Shopify",
  "Offline Only",
  "ONDC",
];

export const HEARD_ABOUT = [
  "",
  "Canton Fair 2026",
  "LinkedIn",
  "Instagram/Social Media",
  "Google Search",
  "Friend / Colleague",
  "Jito/JBN Network",
  "WhatsApp",
  "Other",
];

export const EXPANSION_GOALS = ["", "Start a new category", "Expand existing categories", "Both"];

export const EXPECTED_SKU = ["", "0–10", "10–50", "50–100", "100–1000", "More than 1000"];

export const MOQ_OPTIONS = [
  "",
  "1 piece (sample)",
  "2-10 pieces",
  "10-50 pieces",
  "50-200 pieces",
  "200-500 pieces",
  "500+ pieces",
  "Bulk / Container loads",
];

export const CURRENT_SOURCE = [
  "",
  "Not sourcing yet — new to importing",
  "Alibaba directly",
  "Local Indian wholesaler",
  "Existing China supplier",
  "Other import platforms",
];

export const BUDGET_OPTIONS = [
  "",
  "Under ₹1 Lakh",
  "₹1-5 Lakh",
  "₹5-20 Lakh",
  "₹20-50 Lakh",
  "₹50 Lakh - 1 Cr",
  "Above ₹1 Cr",
];

export const RESELLER_INTEREST = ["", "Yes — tell me more", "Maybe — need more info", "Just exploring right now"];

export const NOT_SOURCING_YET = "Not sourcing yet — new to importing";
